<template>
    <transition name="HotspotEntrance">
        <router-link class="Hotspot" v-show="ready" :to="hotspot.route"
            :class="[getHotspotMutatorClasses, getHotspotContentClass, getHotspotTypeClass]" :style="[getPosition]"
            @click="hotspotPressed">
            <div class="Hotspot__button" :style="[getContinuousHotspotAnimation, getAlternateHotspotIcon]"></div>
            <span v-html="getHotspotTitle"></span>
        </router-link>
    </transition>
</template>

<script>

export default {
    props: ['hotspot'],
    data() {
        return {
            ready: false
        }
    },
    mounted() {
        this.renderHotspotCascade();
    },
    methods: {
        renderHotspotCascade() {
            let delay = 0;
            delay = (this.hotspot.index * 200) + 400;

            setTimeout(() => {
                this.ready = true;
            }, delay);
        },
        getRandomAnimationDelay(min, max) {
            //return a random value for randomly timed animations
            return Math.random() * (max - min) + min;
        },
        hotspotPressed() {
            this.$emit('hotspotPressed', this.hotspot)
        }
    },
    computed: {
        getPosition() {
            return {
                left: this.hotspot.data.positionData.xPosition + 'px',
                top: this.hotspot.data.positionData.yPosition + 'px'
            }
        },
        getHotspotTitle() {
            return this.hotspot.data.alternateTitle && this.hotspot.data.alternateTitle !== '' ? this.hotspot.data.alternateTitle : this.hotspot.data.title;
        },
        getHotspotTypeClass() {
            let hotspotPrefix = "Hotspot--"

            switch (this.hotspot.data.hotspotType) {
                case "No Label":
                    return `${hotspotPrefix}NoLabel`
                case "Thought Bubble":
                    return `${hotspotPrefix}ThoughtBubble`
                case "Speach Bubble":
                    return `${hotspotPrefix}SpeachBubble`
                case "Big Bubble":
                    return `${hotspotPrefix}BigBubble`

                // more types can be added here through the backend hotspotType data value.

                default:
                    return
            }
        },
        getHotspotMutatorClasses() {
            return {
                'Hotspot--flipped': this.hotspot.data.flipped,
                'Hotspot--hidden': this.hotspot.data.hidden,
                'Hotspot--customicon': this.hotspot.data.alternateHotspotIcon !== null
            }
        },
        getHotspotContentClass() {
            if (this.hotspot.componentData) {
                return `Hotspot--${this.hotspot.componentData.type}`
            } else {
                return
            }
        },
        getContinuousHotspotAnimation() {
            // assign the looping animation on hotspots, as well as keeping them synced with resetHotspot.
            return {
                'animation-name': "hotspotLoopPulse",
                'animation-iteration-count': 'infinite',
                'animation-duration': '15s',
                'animation-delay': this.getRandomAnimationDelay(2, 14).toFixed(1) + 's'
            }
        },
        getAlternateHotspotIcon() {
            if (this.hotspot.data.alternateHotspotIcon !== null) {
                return {
                    'background-image': `url(${app.api.Utils.getMediaPath(this.hotspot.data.alternateHotspotIcon.src)})`
                };
            }
        }
    }
}
</script>


<style lang="scss">
$hotspot-height: 50px;

.Hotspot {
    display: flex;

    .Hotspot__button {
        display: flex;
        justify-content: center;
        align-items: center;
        height: $hotspot-height;
        width: $hotspot-height;
        background-color: var(--main-color);
        background-image: url(@/assets/img/ui/plus.svg);
        background-size: 25px;
        background-position: center;
        background-repeat: no-repeat;
        border-radius: 50px;
        transition: background-color 0.5s;
    }

    span {
        display: flex;
        align-items: center;
        white-space: pre-wrap;
        font-weight: bold;
        color: var(--main-color);
        font-size: 20px;
        height: $hotspot-height;
        padding: 0 22px 0 40px;
        background: var(--light-grey);
        margin-left: -25px;
        z-index: -1;
        border-radius: 0 50px 50px 0;

    }

    &:hover {
        span {
            background: rgb(255, 255, 255);
            color: var(--main-color);
        }
    }

    &:focus {
        border-radius: 50%;
    }


    &--flipped {
        flex-direction: row-reverse;

        span {
            padding: 0 28px 0 22px;
            margin-left: auto;
            margin-right: -10px;
            border-radius: 10px 0 0 10px;
        }
    }

    // Styles for specifc components that hotspot can open
    &--fullscreenVideo,
    &--fullscreenIframePlayer {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/play.svg);
        }
    }

    &--externalLink {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/globe.svg);
        }
    }

    &--mail {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/mail.svg);
        }
    }

    // Styles for specific hotspot types defined by getHotspotTypeClass()
    &--NoLabel,
    &--ThoughtBubble,
    &--SpeachBubble {
        span {
            display: none;
        }
    }

    &--SpeachBubble {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/star.svg);
            background-position: 50% 47%;

            &:hover {
                background-color: rgb(255, 255, 255);
            }
        }

    }

    &--ThoughtBubble {
        .Hotspot__button {
            background-image: url(@/assets/img/ui/question.svg);

            &:hover {
                background-color: rgb(255, 255, 255);
            }
        }
    }

    &--BigBubble {
        .Hotspot__button {
            display: none;
        }

        span {

            color: #fff;
            padding: 0 10px;
            text-transform: uppercase;
            font-size: 16px;
            margin-left: 0;
            z-index: -1;
            border-radius: 90px;
            width: 160px;
            height: 160px;
            background: rgb(254, 150, 27);
            background: radial-gradient(circle, rgba(254, 150, 27, 0.29175420168067223) 0%, rgba(254, 150, 27, 0.6839110644257703) 100%);
            transition: background-color 0.3s;


        }

        &:hover {
            span {
                color: #2f3b53;
            }
        }

    }


}

/* entrance animation */
.HotspotEntrance-enter-active {
    transition: all 1s var(--tk-easeinout);
}

.HotspotEntrance-leave-active {
    transition: all 0.3s var(--tk-easeinout);
}

.HotspotEntrance-enter-from {
    transform: translateY(-300%);
    opacity: 0;
}

.HotspotEntrance-leave-to {
    opacity: 0;
}

/* default*/
@keyframes hotspotLoopPulse {
    0% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0.4);
        // transform: scale(0.9);
    }

    7% {
        box-shadow: 0 0 0 220px rgba(255, 255, 255, 0);
        // transform: scale(1);
    }

    10% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(255, 255, 255, 0);
        transform: scale(1);
    }
}
</style>